// import { useLanguage } from "../utils/languageContext";
import Logo from '../../assets/LogoNeuHell.png'
import { useMobile } from '../../utils/mobileContext';
import './footer.css'

const Footer = () => {
    // const { t } = useLanguage();
    const { isMobile } = useMobile(600);

    return (
        <footer>
            <div className='footerContainer'>
                {isMobile ? (
                    <>
                        <img src={Logo} alt='Logo' className='footerImg' />
                        <div className='footerMenusRow'>
                            <ul className='footerUl'>
                                <li style={{marginBottom: 8}}>Impressum</li>
                                <li>Datenschutz</li>
                            </ul>
                            <ul className='footerUl'>
                                <li style={{marginBottom: 8}}>LinkedIn</li>
                                <li>Instagram</li>
                            </ul>
                        </div>
                    </>
                ) : (
                    <>
                        <div>
                            <ul className='footerUl'>
                                <li>Impressum</li>
                                <li>Datenschutz</li>
                            </ul>
                        </div>
                        <img src={Logo} alt='Logo' className='footerImg' />
                        <div>
                            <ul className='footerUl'>
                                <li>LinkedIn</li>
                                <li>Instagram</li>
                            </ul>
                        </div>
                    </>
                )}
            </div>
        </footer>
    );
};

export default Footer;
